module.exports = __webpack_public_path__ + "05_bob_brown.78884aa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/05_bob_brown.png
// module id = phmQ
// module chunks = 0